import {createContext, useEffect, useRef, useState} from 'react';

export enum ThemeTypes {
  SYSTEM = "system",
  DARK = "dark",
  LIGHT = "light",
}

const LS_THEME_SCHEME = 'theme-color-scheme';
const LS_THEME_TYPE = 'theme-control-type';

export const ThemeContext = createContext({});

export const ThemeProvider = ({children}) => {
  // "theme" is only for colors
  const [theme, setTheme] = useState(localStorage.getItem(LS_THEME_SCHEME) || ThemeTypes.LIGHT);
  // "themeType" is how colors should be handled
  const [themeType, setThemeType] = useState(localStorage.getItem(LS_THEME_TYPE) || ThemeTypes.SYSTEM);
  //
  //      tl;dr
  //      When "themeType" is not "system" both "theme" and "themeType" are kind of identical entities
  //      When themeType is "system", "theme" and "themeType" start to response for different actions
  //
  // theme.type needs to be stored for matchMedia.onchange to see the actual type value
  const themeTypeRef = useRef(localStorage.getItem(LS_THEME_TYPE) || ThemeTypes.SYSTEM);
  // handle themeType (auto / manual) and set resulting theme color to the state
  useEffect(() => {
    localStorage.setItem(LS_THEME_TYPE, themeType);
    themeTypeRef.current = themeType;
    if (themeType === ThemeTypes.SYSTEM) {
      const darkThemeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      setTheme(darkThemeMediaQuery.matches ? ThemeTypes.DARK : ThemeTypes.LIGHT);
    } else {
      setTheme(themeType)
    }
  }, [themeType]);
  // listen to system (OS/Browser) theme change
  useEffect(() => {
    const darkThemeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    darkThemeMediaQuery.onchange = e => {
      if (themeTypeRef.current === ThemeTypes.SYSTEM) setTheme(e.matches ? ThemeTypes.DARK : ThemeTypes.LIGHT);
    }
  }, []);
  // store selected (auto or manually) theme color scheme and set corresponding attribute to high level DOM element
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(LS_THEME_SCHEME, theme);
  }, [theme]);

  return <ThemeContext.Provider value={{theme, themeType, setThemeType}}>{children}</ThemeContext.Provider>
};